
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { UIMixin } from "../../../mixins/uiMixin";
import {LoadBetHistory, SetBetHistoryFilters} from "../../../actions/betHistory";
import { addEventCompareConflicts } from '../../../helpers/sport/betslip';
import Zergling from '../../../helpers/zergling';


class BetHistory extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dateFrom: moment().add(-3, 'days'),
            dateTo: moment(),
            openSelectionInfo: null
        };
        this.selectHendlerchange = this.selectHendlerchange.bind(this);
        this.selectBetHistoryInfo = this.selectBetHistoryInfo.bind(this);
        this.copyToBetSlip = this.copyToBetSlip.bind(this);
    }
    
    selectBetHistoryInfo (index) {
        this.setState((state) => {
            return {
                openSelectionInfo: index === state.openSelectionInfo ? null : index
            };
        });
    }
    
    
    copyToBetSlip (index, e) { //TODO Refactoring
        e.stopPropagation()

        const command = (selections, games) => ({
            source: "betting",
            what: {
                sport: ['id', 'alias'],
                region: ['id'],
                competition: ['id'],
                game: [],
                market: [],
                event: ["id", "order", "name", "price", "type", "base"]
            },
            where: { game: { id: { "@in": games } }, event: { id: { "@in": selections } } }
        });

        return async () => {
            const events = this.props.history.bets.map(bet => bet.events) || [];
            const gameIds = new Set()
            const eventIds = events.map(items => (items.map(item => (item.selection_id))));
            for (const bet of this.props.history.bets) {
                for (const event of bet.events) {
                    gameIds.add(event.game_id)
                }
            }

            const fullselectionsTree = (await Zergling.get(command(eventIds[index], gameIds))).data;
            
            Object.keys(fullselectionsTree.sport).filter(item => Object.prototype.hasOwnProperty.call(fullselectionsTree.sport, item)).map(item => {
                const sport = fullselectionsTree.sport[item];
                Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                    const region = sport.region[item];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).map(item => {
                        const competition = region.competition[item];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                            const game = competition.game[item];
                            Object.keys(game.market).filter(item => Object.prototype.hasOwnProperty.call(game.market, item)).map(item => {
                                const market = game.market[item];
                                //this.props.betslipEventsCount.some(eventCount => eventCount === market ? console.log(eventCount, "DONE!!!!!!!!!") : "noooooooo");
                                Object.keys(market.event).filter(item => Object.prototype.hasOwnProperty.call(market.event, item)).map(item => {
                                    const event = market.event[item];
                                    this.props.dispatch(addEventCompareConflicts({
                                        ...game,
                                        alias: sport.alias,
                                        regionId: region.id,
                                        competitionId: competition.id
                                    }, market, event, event.id));                     
                                })
                            })
                        })
                    })
                })
            })          
        };
    }

    selectHendlerchange (id) {
        this.props.dispatch(SetBetHistoryFilters(id));
    }
    componentDidMount () {
        LoadBetHistory(false, {
            from_date: this.props.dateFrom,
            to_date: this.props.dateTo
        })(this.props.dispatch);
    }
    componentDidUpdate (prevprops) {
        if (prevprops.dateFrom !== this.props.dateFrom || prevprops.dateTo !== this.props.dateTo) {
            LoadBetHistory(false, {
                from_date: this.props.dateFrom,
                to_date: this.props.dateTo
            })(this.props.dispatch);
        }
    }

    betHistoryCashout (betId, price) {
        let res = {
            betId,
            price,
            onClose: () => this.props.openPopup('betHistory')
        };

        return () => {
            this.props.closePopup()();
            this.props.openPopup("betHistoryCashout", res)();
        };
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}
BetHistory.propTypes = {
    data: PropTypes.object,
    closePopup: PropTypes.func,
    openPopup: PropTypes.func,
    terminalBalance: PropTypes.number,
    SetBetHistoryFilters: PropTypes.func.isRequired,
    LoadBetHistory: PropTypes.func.isRequired
};
const mapStateToProps = (state) => {
    let swarmDataKey = "betHistory" + (false ? "_unsettled" : "_settled");
    return {
        isLoadedHistory: state.swarmData.loaded[swarmDataKey],
        history: state.swarmData.data[swarmDataKey] || [],
        betHistoryFilterId: state.betHistoryFilters.id,
        dateFrom: state.betHistoryFilters.from_date,
        dateTo: state.betHistoryFilters.to_date
    };
};

export default connect(mapStateToProps)(UIMixin({Component: BetHistory}));